
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import TextControl from "@/components/controls/base/TextControl.vue";

export default defineComponent({
  components: {
    CreateEditDialog,
    TextControl,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  methods: {
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
    onShown(model: any) {
      (this as any).mountComponent(
        "components/catalogues/OrderCommentCatalogue/OrderCommentConstraintSubCatalogueGrid.vue",
        (this as any).constraintSubGridDomId,
        {
          parentModel: model,
        }
      );
      (this as any).mountComponent(
        "components/catalogues/OrderCommentCatalogue/OrderCommentVolumeConstraintSubCatalogueGrid.vue",
        (this as any).volumeConstraintSubGridDomId,
        {
          parentModel: model,
        }
      );
    },
  },
  beforeUnmount() {
    (this as any).unmountComponent((this as any).constraintSubGridDomId);
    (this as any).unmountComponent((this as any).volumeConstraintSubGridDomId);
  },
  data() {
    return {
      constraintSubGridDomId:
        "OrderCommentCreateEditDialog_constraintSubGridDomId",
      volumeConstraintSubGridDomId:
        "OrderCommentCreateEditDialog_volumeConstraintSubGridDomId",
    };
  },
});
